import React, { Component } from 'react';
import axios from 'axios';
import { translate } from 'react-i18next';
import ConecctionsSearch from './ConecctionsSearch.js';
import Conecctions from './Conecctions.js';
import { Redirect } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;

class ConecctionsContainer extends Component {
    getInitState = () => {
        return {
            city: "",
            cities: [],
            busines: "",
            business: [],
            conecctions: [],
            profile: [],
            errorr: "",
            errorQuery: "",
            ConecctionsQuery: "",
            isSearching: false
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        if (this.state.conecctions.length === 0) {
            this.reload();
        }
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        this.getBusiness({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });

        this.getCities({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });

        this.getProfile({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });
    }

    getProfile = (params) => {
        this.props.post(
            "/getProfileUser",
            params,
            (response) => this.didGetProfile(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getBusiness = (params) => {
        this.props.post(
            "/getBusiness",
            params,
            (response) => this.didgetBusiness(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getCities = (params) => {
        this.props.post(
            "/getCities",
            params,
            (response) => this.didgetCities(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getListProfiles = (params) => {
        this.props.post(
            "/getProfileList",
            params,
            (response) => this.didgetListProfile(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getInsertConnectiosData = (params) => {
        this.props.post(
            "/iosferaconnection",
            params,
            (response) => this.didInsert(response),
            (error) => console.log(error),
            cancelToken
        );
    }

    didgetBusiness = (response) => {
        this.setState({ business: response, busines: response[0].id })
    }

    didgetCities = (response) => {
        this.setState({ cities: response })
    }

    didGetProfile = (response) => {
        this.setState({ profile: response })
    }

    didgetListProfile = (response) => {
        this.setState({ conecctions: response })
    }

    didInsert = (response) => {

    }

    handleErrorResponse = (error) => {
        alert('NO SE ENCONTRON PEFILES');
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    handlebusinesChange = (event) => {
        this.setState({ busines: event.target.value });
    }
    handleConecctionsQueryChange = (event) => {
        this.setState({ ConecctionsQuery: event.target.value });
    }

    handleConecctionsSearch = (event) => {
        event.preventDefault();
        this.getListProfiles({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            query: this.state.ConecctionsQuery,
            city_id: this.state.city,
            business_id: this.state.busines,
            center_user: this.state.profile.center_city_id
        });

        this.getInsertConnectiosData({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            business_id: this.state.profile.business_id,
            center_id: this.state.profile.center_city_id,
            contact_business_id: this.state.busines,
            contact_city_id: this.state.city
        });
    }

    renderConecctions = () => {
        return (
            <Conecctions conecctions={this.state.conecctions} />
        );
    }

    rebderConecctionsSearchh = () => {
        return (
            <ConecctionsSearch
                city={this.state.city}
                cities={this.state.cities}
                busines={this.state.busines}
                business={this.state.business}
                ConecctionsQuery={this.state.ConecctionsQuery}
                handleCityChange={this.handleCityChange}
                handlebusinesChange={this.handlebusinesChange}
                handleConecctionsQueryChange={this.handleConecctionsQueryChange}
                handleConecctionsSearch={this.handleConecctionsSearch}
            />
        );
    }

    render() {
        const { t } = this.props;
        if (!this.props.user.memberId) {
            return <Redirect to="/" />;
        }
        return (
            <div className="content-conecctions">
                <div className="container-conecctions-title">
                    <h2 className="page-header">{t('dashboard.conecctions.heading')}</h2>
                </div>
                <div>
                    <div className="content-conecctions-search">
                        {this.rebderConecctionsSearchh()}
                    </div>
                    {this.state.profile.member_id ? (
                        this.state.profile.perfil_publico === "1" ? (
                            <div className="content-conecctions-content">
                                <div id="conecctions">
                                    {this.renderConecctions()}
                                </div>
                            </div>
                        ) : (
                            <h4 className="page-header">
                                {t('dashboard.conecctions.make_puclic_Connection')}
                            </h4>
                        )): null}
                </div>
            </div>
        );
    }

}

export default translate('common')(ConecctionsContainer);


// WEBPACK FOOTER //
// ./src/dashboard/conecctions/ConecctionsContainer.js